const state = {
  rank: {
    monthRank: '',
    totalRank: '',
    weekRank: '',
  },
  search: '',
  book: {
    id: '',
    cover: '',
    title: ''
  },
  // 一级
  navInde: localStorage.getItem('navInde') || 0,
  swpierIndex: localStorage.getItem('swpierIndex') || 0,
  //二级
  secondCategroy:localStorage.getItem('secondCategroy') || null,
  swipersecondCategroy:localStorage.getItem('swipersecondCategroy') || null,
  secondCategroy02:localStorage.getItem('secondCategroy02') || null,
  swipersecondCategroy02:localStorage.getItem('swipersecondCategroy02') || null,
  secondCategroy03:localStorage.getItem('secondCategroy03') || null,
  swipersecondCategroy03:localStorage.getItem('swipersecondCategroy03') || null,
  secondCategroy04:localStorage.getItem('secondCategroy04') || null,
  swipersecondCategroy04:localStorage.getItem('swipersecondCategroy04') || null,
  loginUserImg: null,
};
export default state
